import b from "./highrise999.mjs";
import { createTheme as v } from "./highrise984.mjs";
import I from "./highrise1000.mjs";
import H from "./highrise987.mjs";
function S(r) {
  const {
    textColor1: e,
    textColor2: l,
    modalColor: t,
    closeIconColor: i,
    closeIconColorHover: n,
    closeIconColorPressed: s,
    closeColorHover: c,
    closeColorPressed: C,
    infoColor: m,
    successColor: a,
    warningColor: d,
    errorColor: g,
    primaryColor: f,
    dividerColor: u,
    borderRadius: o,
    fontWeightStrong: p,
    lineHeight: h,
    fontSize: x
  } = r;
  return Object.assign(Object.assign({}, b), {
    fontSize: x,
    lineHeight: h,
    border: `1px solid ${u}`,
    titleTextColor: e,
    textColor: l,
    color: t,
    closeColorHover: c,
    closeColorPressed: C,
    closeIconColor: i,
    closeIconColorHover: n,
    closeIconColorPressed: s,
    closeBorderRadius: o,
    iconColor: f,
    iconColorInfo: m,
    iconColorSuccess: a,
    iconColorWarning: d,
    iconColorError: g,
    borderRadius: o,
    titleFontWeight: p
  });
}
const O = v({
  name: "Dialog",
  common: H,
  peers: {
    Button: I
  },
  self: S
});
export {
  O as default,
  S as self
};
